














































import selectbox from '@/components/selectbox/index.vue';
import { defineComponent, ref, watch } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { TAB_NAME } from '../../const';
import { DataCenterModel } from '../../model';
import chartModule from '../chart-module.vue';
import sumDisplay from '../sum-display.vue';

export default defineComponent({
    components: {
        selectbox,
        sumDisplay,
        chartModule,
    },
    props: {
        lastVisitApp: String,
    },
    setup(props, context) {
        const model = useApolloModel(DataCenterModel);
        const selectedApp = ref('');
        const activeTab = ref('');
        async function postVisitedId() {
            if (model.appId && model.dataTab) {
                await model.reportVisitMutate({
                    appId: model.appId,
                    tabName: model.dataTab,
                });
            }
        }

        model.appId = props.lastVisitApp || '';
        model.dataTab = TAB_NAME.GAMETAB;
        selectedApp.value = props.lastVisitApp || '';

        function gotoContorllCenter() {
            context.root.$router.push({
                path: '/platform/controllCenter/mobile',
            });
        }

        watch(
            () => selectedApp.value,
            async (val: string) => {
                model.appId = val;
                await postVisitedId();
            },
            { immediate: true },
        );

        return {
            model,
            selectedApp,
            activeTab,
            gotoContorllCenter,
        };
    },
});
